import { useQuery } from '@tanstack/react-query'
import {
  WATER_QUALITY_THRESHOLD_KEY,
  MEAL_THRESHOLD_KEY,
  SHRIMP_HEALTH_THRESHOLD_KEY,
} from 'common/constants/queryKeys'

import { getWaterQualityThreshold, getMealThreshold, getShrimpHealthThreshold } from '.'

export const useGetWaterQualityThreshold = () => {
  return useQuery({
    queryKey: WATER_QUALITY_THRESHOLD_KEY,
    queryFn: async () => {
      const { data } = await getWaterQualityThreshold()
      return data.data.thresholds
    },
    staleTime: Infinity,
  })
}

export const useGetMealThreshold = () => {
  return useQuery({
    queryKey: MEAL_THRESHOLD_KEY,
    queryFn: async () => {
      const { data } = await getMealThreshold()
      return data.data.thresholds
    },
    staleTime: Infinity,
  })
}

export const useGetShrimpHealthThreshold = () => {
  return useQuery({
    queryKey: SHRIMP_HEALTH_THRESHOLD_KEY,
    queryFn: async () => {
      const { data } = await getShrimpHealthThreshold()
      return data.data.thresholds
    },
    staleTime: Infinity,
  })
}
